import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { DropdownModule } from 'primeng/dropdown';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { AuthenticationGuard } from '../../auth/authentication.guard';
import { LocationsService } from '../../locations/state/locations.service';
import { MessageListModule } from '../../message-list/message-list.module';
import { AppointmentListModule } from '../appointment-list/appointment-list.module';
import { AppointmentListService } from '../appointment-list/state/appointment-list.service';
import { MessageFilterModule } from '../message-filter/message-filter.module';
import { GlobalSettingsSelectors } from '../reminder-settings/global-settings/state/global-settings.selectors';
import { StrategyService } from '../reminder-settings/state/strategy.service';
import { PatientAppointmentsComponent } from './patient-appointments.component';
import { PatientDetailsComponent } from './patient-details.component';
import { PatientMessagesComponent } from './patient-messages.component';
import { PatientReminderSettingsComponent } from './patient-reminder-settings.component';
import { PatientTabsComponent } from './patient-tabs.component';
import { PatientsSearchComponent } from './patients-search.component';
import { PatientsComponent } from './patients.component';
import { PetsDetailComponent } from './pets-detail.component';
import { PatientAppointmentService } from './state/patient-appointment.service';
import { PatientsActions } from './state/patients.actions';
import { PatientsEffects } from './state/patients.effects';
import { PatientsReducer, STORE_FEATURE_KEY_PATIENTS } from './state/patients.reducers';
import { PatientsSelectors } from './state/patients.selectors';
import { PatientsServices } from './state/patients.services';
import { SubscriptionsDialogComponent } from './subscriptions-dialog.component';
import { FeatureFlagsModule } from "../../feature-flag/feature-flag.module";

@NgModule({
  imports: [
    CommonModule,

    RouterModule.forChild([
      {
        path: '',
        component: PatientsComponent,
        children: [
          // TODO: ADD LAZY LOADING?
          {path: '', redirectTo: 'appointments', pathMatch: 'full'},
          {path: 'appointments', component: PatientAppointmentsComponent, canActivate: [AuthenticationGuard]},
          {path: 'messages', component: PatientMessagesComponent, canActivate: [AuthenticationGuard]}
        ]
      }]),

    FormsModule,
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    DropdownModule,
    TabMenuModule,
    TabViewModule,
    TranslateModule,

    AppointmentListModule,
    MessageListModule,
    StoreModule.forFeature(STORE_FEATURE_KEY_PATIENTS, PatientsReducer),
    EffectsModule.forFeature([PatientsEffects]),
    ReactiveFormsModule,
    MessageFilterModule,
    FeatureFlagsModule
  ],
  declarations: [
        PatientsComponent,
        PatientTabsComponent,
        PatientReminderSettingsComponent,
        PatientDetailsComponent,
        PatientAppointmentsComponent,
        PatientMessagesComponent,
        PatientsSearchComponent,
        SubscriptionsDialogComponent,
        PetsDetailComponent
    ],
  providers: [
        StrategyService,
        PatientsServices,
        PatientAppointmentService,
        PatientsSelectors,
        PatientsActions,
        GlobalSettingsSelectors,
        AppointmentListService,
        LocationsService
    ]
})
export class PatientsModule {
}
